import {
    ResourceFormState,
} from "@/employer/types";

import {
    FetchState,
    PartnerFormDocumentResponse,
    ResourceFormDocumentSavePayload,
    ResourceFormDocument,
    FormDocumentOptOutRequest,
    FormDocumentAssociationType, ResourceFormDocumentBase
} from "@/shared/types";
import Vue from "vue";
import { defineStore } from "pinia";
import _ from "lodash";
import * as resourceFormService from "@/shared/api/ResourceFormService";
import * as storeHelper from "@/shared/storeHelper";
import moment from "moment";
export const initialState: ResourceFormState = {
    fetchStates: {},
    resourceFormData: {},
};

export const useResourceFormStore = defineStore("resorceForm", {
    state: () => (_.cloneDeep(initialState)),
    getters: {
        getFetchStateByPartner: state => partnerId => state.fetchStates[partnerId],
        getResourceFormsByPartner: state => partnerId => state.resourceFormData[partnerId].documents,
        getPlanTypesByPartner: state => partnerId => state.resourceFormData[partnerId].supportedPlanTypes,
        getPartnersServicedByPartner: state => partnerId => state.resourceFormData[partnerId].partnersServiced,
        isPartnerLoaded: state => partnerId => state.fetchStates[partnerId] === FetchState.Loaded,
        isPartnerAnAdminPartner: state => partnerId => state.resourceFormData[partnerId].isAdminPartner,
        isPartnerASellingPartner: state => partnerId => state.resourceFormData[partnerId].isSellingPartner,
    },
    actions: {
        setFetchStateForPartner (params: { partnerId: number, fetchState: FetchState }) {
            Vue.set(this.fetchStates, params.partnerId, params.fetchState);
        },
        setResourceFormDataForPartner (params: { partnerId: number, item: PartnerFormDocumentResponse }) {
            Vue.set(this.resourceFormData, params.partnerId, params.item);
        },
        addResourceFormToPartner (params: { partnerId: number, item: ResourceFormDocument }) {
            this.resourceFormData[params.partnerId].documents.push(params.item);

        },
        loadResourceFormsForPartner (partnerId: number) {
            this.setFetchStateForPartner({ partnerId, fetchState: FetchState.Loading });

            return resourceFormService.getResourceFormDocumentsByPartnerId(partnerId)
                .then(response => {
                    this.setResourceFormDataForPartner({ partnerId, item: response.data });
                    this.setFetchStateForPartner({ partnerId, fetchState: FetchState.Loaded });
                })
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
        optInOrOptOut (params: {
            partnerId: number,
            formDocumentId: number,
            isOptOut: boolean
        }) {
            const payload: FormDocumentOptOutRequest = {
                isOptOut: params.isOptOut,
                formDocumentId: params.formDocumentId
            };
            return resourceFormService.putFormDocumentOptInOrOptOut(params.partnerId, payload)
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
        saveResourceForm (params: {
            partnerId: number,
            resourceForm: ResourceFormDocumentBase
        }) {
            const payload: ResourceFormDocumentSavePayload = {
                FormDocumentId: params.resourceForm.formDocumentId,
                DownloadUrl: params.resourceForm.downloadUrl,
                DisplayName: params.resourceForm.displayName,
                PlanTypes: params.resourceForm.planTypes,
                DateAvailableStart: moment(params.resourceForm.dateAvailableStart).format("YYYY-MM-DD"),
                DateAvailableEnd: params.resourceForm.dateAvailableEnd ? moment(params.resourceForm.dateAvailableEnd).format("YYYY-MM-DD") : null,
                Employers: params.resourceForm.employers,
                SellingPartnerIds: params.resourceForm.sellingPartnerIds
            };
            return resourceFormService.addOrUpdateResourceForm(params.partnerId, payload)
                .then(
                    response => {
                        if (params.resourceForm.formDocumentId === 0) {
                            // new form, add it to the list and get the id from the response
                            const item: ResourceFormDocument = {
                                formDocumentId: response.data,
                                displayName: params.resourceForm.displayName,
                                downloadUrl: params.resourceForm.downloadUrl,
                                dateAvailableStart: params.resourceForm.dateAvailableStart,
                                dateAvailableEnd: params.resourceForm.dateAvailableEnd,
                                planTypes: params.resourceForm.planTypes,
                                sellingPartnerIds: params.resourceForm.sellingPartnerIds,
                                employers: params.resourceForm.employers,
                                associations: [
                                    FormDocumentAssociationType.AdminPartnerCreated
                                ],
                                isActive: false,
                                canOptOut: false,
                                isOptedOut: false
                            };
                            this.addResourceFormToPartner({ partnerId: params.partnerId, item });
                        }
                    }
                )
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        }
    }
});